import React from 'react';
import { NavLink } from 'react-router-dom';
import {
  LayoutDashboard,
  Package,
  ShoppingBag,
  User,
  X,
  LogOut,
  Calculator,
  Handshake,
  Percent,
  BarChart3,
  Layers,
  Settings2,
} from 'lucide-react';
import { useAuth } from '@/features/auth/hooks/useAuth';

const NAV_ITEMS = [
  { to: '/vendor/dashboard', label: 'داشبورد', icon: LayoutDashboard, end: true },
  { to: '/vendor/products', label: 'محصولات', icon: Package },
  { to: '/vendor/orders', label: 'سفارشات', icon: ShoppingBag },
  { to: '/vendor/pricing-rules', label: 'مبنای محاسبات قیمت', icon: Settings2 },
  { to: '/vendor/packages/create', label: 'انتخاب سبدکالا جهت خریدار خرد', icon: Calculator },
  { to: '/vendor/packages', label: 'سبدهای فروش من', icon: Layers, end: true },
  { to: '/vendor/contracts', label: 'قراردادهای فروش پکیج شرکتی', icon: Handshake },
  { to: '/vendor/commissions', label: 'مدیریت پورسانت‌ها', icon: Percent },
  { to: '/vendor/reports', label: 'گزارش جامع فروش', icon: BarChart3, end: true },
  { to: '/vendor/profile', label: 'پروفایل', icon: User },
];

export default function VendorSidebar({ isOpen, onClose, onLogout }) {
  const { referralEnabled } = useAuth();

  const visibleItems = NAV_ITEMS.filter(
      (item) => !item.requiresReferral || referralEnabled
  );

  return (
      <>
        {isOpen && (
            <div className="vendor-sidebar-overlay" onClick={onClose} />
        )}

        <aside className={`vendor-sidebar glass-sidebar ${isOpen ? 'open' : ''}`}>
          {/* هدر سایدبار بدون عنوان (فقط دکمه بستن در موبایل) */}
          <div className="vendor-sidebar-header">
            <button onClick={onClose} className="vendor-sidebar-close hidden-mobile" aria-label="بستن منو">
              <X size={18} />
            </button>
          </div>

          <nav className="vendor-nav">
            {visibleItems.map(({ to, label, icon: Icon, end }) => (
                <NavLink
                    key={to}
                    to={to}
                    end={end}
                    onClick={onClose}
                    className={({ isActive }) => `vendor-nav-item ${isActive ? 'active' : ''}`}
                    title={label}
                >
                  <Icon size={20} className="nav-icon" />
                  <span className="vendor-nav-label">{label}</span>
                </NavLink>
            ))}
          </nav>

          <button onClick={onLogout} className="vendor-nav-item vendor-logout-btn" title="خروج">
            <LogOut size={20} className="nav-icon" />
            <span className="vendor-nav-label">خروج</span>
          </button>
        </aside>
      </>
  );
}